export default __webpack_public_path__ + "static/media/login-slide-4.f97c1bb1.svg";